import { useEffect } from "react";
import {
  isDevelopmentEnvironment,
  isPushSubscriptionEnabled,
  shouldSyncPushSubscription,
  syncPushSubscription,
} from "../Utilits/pushSubscription";

const usePushSubscriptionSync = (
  companyId: number,
  isAnyServiceEnabled: boolean,
) => {
  useEffect(() => {
    if (!companyId || !isAnyServiceEnabled) {
      return;
    }

    if (isDevelopmentEnvironment()) {
      return;
    }

    if (!isPushSubscriptionEnabled(companyId)) {
      return;
    }

    if (!shouldSyncPushSubscription(companyId)) {
      return;
    }

    void syncPushSubscription(companyId);
  }, [companyId, isAnyServiceEnabled]);
};

export default usePushSubscriptionSync;
